import { faTrashXmark, faUserDoctor } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Typography } from "@mui/material";
import IOSSwitchDarkGreen from "../../../components/IosSwitchDarkGreen";
import { PrestadorConsultado } from "../../../interfaces/entities/Permissoes/PrestadorConsultado";
import './styles.css';
import { sxBoxActions, sxDarkGreyBody, sxFormTitle, sxTrustedDoctorsCardContainer } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import ModalActionResponsive from "../../../components/ModalActionResponsive";
import { useState } from "react";
import { excluirPrestadorConfianca } from "../../../services/PermissoesService";
import LoadingApp from "../../../components/LoadingApp";

const AllowedDoctorCard: React.FC<{
  doctorConsulted: PrestadorConsultado,
  handleChangeDoctorPermission?: () => void,
  fetchDoctors?: () => void,
  showExcluir?: boolean,
}> = ({ doctorConsulted, handleChangeDoctorPermission, fetchDoctors, showExcluir }) => {

  const accessibility = useAccessibility();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const handleDeletePrestadorConfianca = () => {
    setLoading(true)
    excluirPrestadorConfianca({
      idPermisBenefPrestador: doctorConsulted.idPermisBenefPrestador,
      idPessoaPrestador: doctorConsulted.idPrestador
    }).then(() => {
      setTimeout(() => {
        fetchDoctors && fetchDoctors();
        setShowModal(false);
        setLoading(false)
      }, 2000);
    }).catch(() => {
      setShowModal(false);
      setLoading(false)
    })
  }


  return (
    <>
      <Box sx={sxTrustedDoctorsCardContainer} style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }} tabIndex={0}>
        <Box display={'flex'} alignItems={'center'} gap={'16px'}>
          <FontAwesomeIcon style={{ ...accessibility.contrastColorAccessibility }} icon={faUserDoctor} className="fa-icon32x32" />
          <div>
            <Typography style={accessibility.textStyleAccessibility} sx={sxFormTitle}>{doctorConsulted.nome}</Typography>
            <Typography style={accessibility.textStyleAccessibility} sx={sxDarkGreyBody}>{doctorConsulted.especialidade}</Typography>
          </div>
        </Box>
        <Box sx={sxBoxActions}>
          <IOSSwitchDarkGreen
            sx={{ marginLeft: '8px' }}
            checked={doctorConsulted.indAtivo}
            onChange={handleChangeDoctorPermission}
            aria-label={`${doctorConsulted.indAtivo ? 'Desativar' : 'Ativar'} ${doctorConsulted.nome}, ${doctorConsulted.especialidade} da lista de médicos de confiança`}
          />
          <div aria-live="polite">
            { showExcluir &&
              <IconButton
                style={accessibility.buttonStyleAccessibility}
                onClick={() => setShowModal(true)}
                aria-label={`Remover ${doctorConsulted.nome}, ${doctorConsulted.especialidade} da lista de médicos de confiança`}
              >
                <FontAwesomeIcon icon={faTrashXmark} color={accessibility.contrastMode ? '' : '#CC3D3D'} />
              </IconButton>
            }
          </div>
        </Box>
        <ModalActionResponsive
          showModal={showModal}
          textContainedButton="Remover"
          textOutlinedButton="Cancelar"
          title="Remover médico(a)"
          subTitle="Tem certeza que deseja remover o(a) médico(a) da lista de Médicos de confiança?"
          icon='warning'
          width="509px"
          handleContainedButton={handleDeletePrestadorConfianca}
          handleOutlinedButton={() => setShowModal(false)}
          handleShowModal={() => setShowModal(false)}
        />

        <LoadingApp showLoading={loading} text='Carregando...' />
      </Box>
      
    </>
  )
}

export default AllowedDoctorCard;